import { Component, ChangeDetectionStrategy } from "@angular/core";
import { ALLOWED_CHARACTERS } from "src/config/allowed-characters.config";
import { PrefixTextComponent } from "../../prefix-text.component";
import { TemplateTextComponent } from "../../templates/template-text/template-text.component";
import { MaxLength } from "../../types/MaxLength";

@Component({
  selector: "app-prefix-naa",
  imports: [TemplateTextComponent],
  templateUrl: "./prefix-naa.component.html",
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: "./prefix-naa.component.less",
})
export class PrefixNaaComponent extends PrefixTextComponent {
  public maxlength: MaxLength;

  public constructor() {
    super();
    this.maxlength = 30;
    this.required = true;
    this.characters = ALLOWED_CHARACTERS["naa"];
  }
}
